<template>
  <v-avatar
    :size="size"
  >
    <v-img :src="$imageUrl(avatar, 'avatars')" />
  </v-avatar>
</template>

<script>
const DEFAULT = '1_0';

export default {
  name: 'BaseAvatar',
  props: {
    size: {
      type: [String, Number],
      default: '48',
    },
    img: {
      type: String,
      default: '',
    },
    default: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    avatar: DEFAULT,
  }),
  watch: {
    img: {
      immediate: true,
      handler() {
        if (this.img) {
          this.avatar = this.img;
        } else if (!this.default) {
          this.avatar = this.$store.state.session.pic || DEFAULT;
        } else {
          this.avatar = DEFAULT;
        }
      },
    },
  },
};
</script>
